import type { IntrinsicSystemProps } from '@hover/blueprint';
import { forwardRef, system } from '@hover/blueprint';
import React from 'react';

interface GeneratedImagePlaceholderProps extends IntrinsicSystemProps<'div'> {
  src?: string;
}

const GeneratedImagePlaceholder = forwardRef<
  GeneratedImagePlaceholderProps,
  'div'
>(({ background, bg, src, ...props }, ref) => (
  <system.div
    background={src ? `url(${src})` : background ?? bg}
    backgroundPosition="center"
    backgroundSize="cover"
    bottom="-5px"
    filter="blur(5px) saturate(0)"
    left="-5px"
    opacity="0.25"
    position="absolute"
    right="-5px"
    top="-5px"
    {...props}
    ref={ref}
  />
));

export { GeneratedImagePlaceholder };
